import { Form, Formik } from "formik";
import { phoneRegex } from "utils";
import * as Yup from "yup";
import AccountField from "../AccountField";
import useUpdateInstitution from "api/InstitutionResource/useUpdateInstitution";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { countries, institutionLevels } from "utils/data";
import useSearchParams from "hooks/useSearchParams";
import useGetProvinces from "api/Province/useGetProvinces";

const UpdateInstitution = ({
	institutionId,
	name,
	level,
	address,
	country,
	contactNumber,
	province,
}) => {
	const { getParam } = useSearchParams();

	const returnUrl = getParam("returnUrl") || "";

	const { data: provinces, isLoading: isLoadingProvinces } = useGetProvinces();

	const initialValues = {
		name: name || "",
		level: level || "",
		address: address || "",
		country: country || "",
		contact_number: contactNumber || "",
		province: province || "",
	};

	const validate = Yup.object().shape({
		name: Yup.string().required("Name of institution is required"),
		country: Yup.string().required("Country is required"),
		province: Yup.string().when("country", {
			is: (val) => val === "Zimbabwe",
			then: Yup.string().required("Province is required"),
		}),
		contact_number: Yup.string()
			.required("Contact number is required")
			.matches(phoneRegex, "Use a valid phone number with country code")
			.min(10, "Use at least 10 characters")
			.max(20, "Use no more than 20 characters"),
	});

	const { mutateAsync, isLoading } = useUpdateInstitution(institutionId, returnUrl);

	const handleSave = async (data) => {
		await mutateAsync(data);
	};

	return (
		<>
			<div>
				<p className="text-base">
					Update details for <span className="font-bold">{name}</span>
				</p>
				<p>Fields marked (*) are required</p>

				<div className="mt-4 pt-4">
					<Formik
						initialValues={initialValues}
						enableReinitialize
						validationSchema={validate}
						onSubmit={(data) => handleSave(data)}
					>
						{({ values }) => (
							<Form className="account-security-fields">
								<AccountField name="name" label="Name of Institution *" />

								<AccountField
									type="select"
									name="country"
									label="Country *"
									options={countries.map((country) => ({
										label: country.name,
										value: country.name,
									}))}
								/>

								<div className={`relative ${values.country === "Zimbabwe" ? "" : "hidden"}`}>
									<AiOutlineLoading3Quarters
										size={20}
										className={`${
											isLoadingProvinces ? "animate-spin" : "hidden"
										} absolute top-2 right-14 z-10`}
									/>
									<AccountField
										type="select"
										name="province"
										label="Province *"
										disabled={isLoadingProvinces}
										options={provinces?.map((province) => ({
											label: province.name,
											value: province.name,
										}))}
									/>
								</div>

								<AccountField
									name="contact_number"
									type="phone"
									label="Contact Number *"
									autoComplete="tel"
									// placeholder="+263 77 123 4567"
								/>

								<AccountField name="address" label="Physical Address" />

								<AccountField
									type="select"
									name="level"
									label="Institution Level *"
									options={institutionLevels.map((level) => ({
										label: level.name,
										value: level.value,
									}))}
								/>

								<div className="mt-4 flex items-center">
									<button type="submit" className="account-button" disabled={isLoading}>
										Update details
										{isLoading && <AiOutlineLoading3Quarters size={20} className="animate-spin" />}
									</button>
								</div>
							</Form>
						)}
					</Formik>
				</div>
			</div>
		</>
	);
};

export default UpdateInstitution;
